// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-resource-resource-picker-card .ant-card-head {
  margin-bottom: 0;
  padding: 0 12px;
}
.ngw-resource-resource-picker-card .ant-card-body {
  padding: 0;
}
.ngw-resource-resource-picker-card .ant-card-actions {
  padding: 0 12px;
}
.ngw-resource-resource-picker-card .ant-modal-footer .ant-input {
  text-align: left;
}
.ngw-resource-resource-picker-card .resource-breadcrumb .ant-breadcrumb-link {
  display: inline-flex;
}
.ngw-resource-resource-picker-card .resource-breadcrumb .ant-breadcrumb-link .resource-breadcrumb-item {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/component/resource-picker/ResourcePickerCard.less"],"names":[],"mappings":"AAAA;EAEQ,gBAAA;EACA,eAAA;AAAR;AAHA;EAOQ,UAAA;AADR;AANA;EAWQ,eAAA;AAFR;AATA;EAeQ,gBAAA;AAHR;AAZA;EAoBY,oBAAA;AALZ;AAfA;EAuBgB,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALhB","sourcesContent":[".ngw-resource-resource-picker-card {\n    .ant-card-head {\n        margin-bottom: 0;\n        padding: 0 12px;\n    }\n\n    .ant-card-body {\n        padding: 0;\n    }\n\n    .ant-card-actions {\n        padding: 0 12px;\n    }\n\n    .ant-modal-footer .ant-input {\n        text-align: left;\n    }\n\n    .resource-breadcrumb {\n        .ant-breadcrumb-link {\n            display: inline-flex;\n\n            .resource-breadcrumb-item {\n                max-width: 220px;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
